import { useState, useEffect, useCallback } from "react";
import { log } from "@/lib/log";

const KEY = "archedia-compare";
const EVENT = "archedia-compare-change";
const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { log.warn("compare storage unreadable", e); return []; }
};
const persist = (next) => {
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { log.warn("compare storage unavailable", e); }
  window.dispatchEvent(new Event(EVENT));
};

export function useCompare() {
  const [ids, setIds] = useState(read);

  useEffect(() => {
    const h = () => setIds(read());
    window.addEventListener(EVENT, h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener(EVENT, h);
      window.removeEventListener("storage", h);
    };
  }, []);

  const toggle = useCallback((id) => {
    const prev = read();
    if (prev.includes(id)) { persist(prev.filter((x) => x !== id)); return { ok: true, added: false }; }
    if (prev.length >= 3) return { ok: false, added: false, full: true };
    persist([...prev, id]);
    return { ok: true, added: true };
  }, []);

  const remove = useCallback((id) => persist(read().filter((x) => x !== id)), []);
  const clear = useCallback(() => persist([]), []);

  return { ids, toggle, remove, clear };
}
